<template>
  <f7-page class="page-message-detail" @page:init="getMessageDetail" @page:reinit="getMessageDetail">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>TIN NHẮN - {{ title_play_style(region, playStyle) }}</f7-nav-title>
    </f7-navbar>
    <f7-row>
      <f7-col>
        <div class="data-table sm bordered card">
          <table>
            <thead>
            <tr>
              <th style="width: 33%" class="text-align-center">XÁC</th>
              <th style="width: 33%" class="text-align-center">QUA CÒ</th>
              <th class="text-align-center">TRÚNG</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="vertical-align-top p-0">
                <ul class="list-style-none pl-0">
                  <li v-if="sum_point_1c > 0">
                    <span class="command_type">{{ command_play_style('1C', playStyle) }}:</span>
                    {{ sum_cost_without_rate_1c | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_giainhat > 0">
                    <span class="command_type">{{ command_play_style('GNhat', playStyle) }}:</span>
                    {{ sum_cost_without_rate_giainhat | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_bao > 0">
                    <span class="command_type">{{ command_play_style('2CB', playStyle) }}:</span>
                    {{ sum_cost_without_rate_2c_bao | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_dd > 0">
                    <span class="command_type">{{ command_play_style('2CĐ', playStyle) }}:</span>
                    {{ sum_cost_without_rate_2c_dd | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_win_without_win_rate_2c_ui > 0" style="height: 1.4em">&nbsp;</li>
                  <li v-if="sum_point_2c_bay > 0">
                    <span class="command_type">2CB7:</span>
                    {{ sum_cost_without_rate_2c_bay | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_tam > 0">
                    <span class="command_type">2CB8:</span>
                    {{ sum_cost_without_rate_2c_tam | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_dat > 0">
                    <span class="command_type">ĐáT:</span>
                    {{ sum_cost_without_rate_2c_dat | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_dax > 0">
                    <span class="command_type">ĐáX:</span>
                    {{ sum_cost_without_rate_2c_dax | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_dax2 > 0">
                    <span class="command_type">{{ command_play_style('ĐáX2', playStyle) }}:</span>
                    {{ sum_point_2c_dax2 | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_dax3 > 0">
                    <span class="command_type">{{ command_play_style('ĐáX3', playStyle) }}:</span>
                    {{ sum_point_2c_dax3 | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_dax4 > 0">
                    <span class="command_type">{{ command_play_style('ĐáX4', playStyle) }}:</span>
                    {{ sum_point_2c_dax4 | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_3c_bao > 0">
                    <span class="command_type">{{ command_play_style('3CB', playStyle) }}:</span>
                    {{ sum_cost_without_rate_3c_bao | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_3c_bay > 0">
                    <span class="command_type">3CB7:</span>
                    {{ sum_cost_without_rate_3c_bay | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_3c_xc > 0">
                    <span class="command_type">{{ command_play_style('3CXC', playStyle) }}:</span>
                    {{ sum_cost_without_rate_3c_xc | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_4c > 0">
                    <span class="command_type">4C:</span>
                    {{ sum_cost_without_rate_4c | numeral('0,0[.]0') }}
                  </li>
                </ul>
              </td>
              <td class="vertical-align-top p-0">
                <ul class="list-style-none pl-0">
                  <li v-if="sum_point_1c > 0">
                    <span class="command_type">{{ command_play_style('1C', playStyle) }}:</span>
                    {{ sum_cost_1c | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_giainhat > 0">
                    <span class="command_type">{{ command_play_style('GNhat', playStyle) }}:</span>
                    {{ sum_cost_giainhat | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_bao > 0">
                    <span class="command_type">{{ command_play_style('2CB', playStyle) }}:</span>
                    {{ sum_cost_2c_bao | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_dd > 0">
                    <span class="command_type">{{ command_play_style('2CĐ', playStyle) }}:</span>
                    {{ sum_cost_2c_dd | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_win_without_win_rate_2c_ui > 0" style="height: 1.4em">&nbsp;</li>
                  <li v-if="sum_point_2c_bay > 0">
                    <span class="command_type">2CB7:</span>
                    {{ sum_cost_2c_bay | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_tam > 0">
                    <span class="command_type">2CB8:</span>
                    {{ sum_cost_2c_tam | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_dat > 0">
                    <span class="command_type">ĐáT:</span>
                    {{ sum_cost_2c_dat | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_dax > 0">
                    <span class="command_type">ĐáX:</span>
                    {{ sum_cost_2c_dax | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_dax2 > 0">
                    <span class="command_type">{{ command_play_style('ĐáX2', playStyle) }}:</span>
                    {{ sum_cost_2c_dax2 | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_dax3 > 0">
                    <span class="command_type">{{ command_play_style('ĐáX3', playStyle) }}:</span>
                    {{ sum_cost_2c_dax3 | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_2c_dax4 > 0">
                    <span class="command_type">{{ command_play_style('ĐáX4', playStyle) }}:</span>
                    {{ sum_cost_2c_dax4 | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_3c_bao > 0">
                    <span class="command_type">{{ command_play_style('3CB', playStyle) }}:</span>
                    {{ sum_cost_3c_bao | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_3c_bay > 0">
                    <span class="command_type">3CB7:</span>
                    {{ sum_cost_3c_bay | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_3c_xc > 0">
                    <span class="command_type">{{ command_play_style('3CXC', playStyle) }}:</span>
                    {{ sum_cost_3c_xc | numeral('0,0[.]0') }}
                  </li>
                  <li v-if="sum_point_4c > 0">
                    <span class="command_type">4C:</span>
                    {{ sum_cost_4c | numeral('0,0[.]0') }}
                  </li>
                </ul>
              </td>
              <td class="vertical-align-top p-0">
                <ul class="list-style-none pl-0">
                  <li v-if="sum_point_1c > 0">
                    <span class="command_type">{{ command_play_style('1C', playStyle) }}:</span>
                    {{ sum_win_without_win_rate_1c | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_point_giainhat > 0">
                    <span class="command_type">{{ command_play_style('GNhat', playStyle) }}:</span>
                    {{ sum_win_without_win_rate_giainhat | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_point_2c_bao > 0">
                    <span class="command_type">{{ command_play_style('2CB', playStyle) }}:</span>
                    {{ sum_win_without_win_rate_2c_bao | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_point_2c_dd > 0">
                    <span class="command_type">{{ command_play_style('2CĐ', playStyle) }}:</span>
                    {{ sum_win_without_win_rate_2c_dd | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_win_without_win_rate_2c_ui > 0">
                    <span class="command_type">An Ủi:</span>
                    {{ sum_win_without_win_rate_2c_ui | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_point_2c_bay > 0">
                    <span class="command_type">2CB7:</span>
                    {{ sum_win_without_win_rate_2c_bay | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_point_2c_tam > 0">
                    <span class="command_type">2CB8:</span>
                    {{ sum_win_without_win_rate_2c_tam | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_point_2c_dat > 0">
                    <span class="command_type">ĐáT:</span>
                    {{ sum_win_without_win_rate_2c_dat | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_point_2c_dax > 0">
                    <span class="command_type">ĐáX:</span>
                    {{ sum_win_without_win_rate_2c_dax | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_point_2c_dax2 > 0">
                    <span class="command_type">{{ command_play_style('ĐáX2', playStyle) }}:</span>
                    {{ sum_win_without_win_rate_2c_dax2 | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_point_2c_dax3 > 0">
                    <span class="command_type">{{ command_play_style('ĐáX3', playStyle) }}:</span>
                    {{ sum_win_without_win_rate_2c_dax3 | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_point_2c_dax4 > 0">
                    <span class="command_type">{{ command_play_style('ĐáX4', playStyle) }}:</span>
                    {{ sum_win_without_win_rate_2c_dax4 | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_point_3c_bao > 0">
                    <span class="command_type">{{ command_play_style('3CB', playStyle) }}:</span>
                    {{ sum_win_without_win_rate_3c_bao | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_point_3c_bay > 0">
                    <span class="command_type">3CB7:</span>
                    {{ sum_win_without_win_rate_3c_bay | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_point_3c_xc > 0">
                    <span class="command_type">{{ command_play_style('3CXC', playStyle) }}:</span>
                    {{ sum_win_without_win_rate_3c_xc | numeral('0,0[.]00') }}
                  </li>
                  <li v-if="sum_point_4c > 0">
                    <span class="command_type">4C:</span>
                    {{ sum_win_without_win_rate_4c | numeral('0,0[.]00') }}
                  </li>
                </ul>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3" :class="{'text-color-forestgreen': sum_total >= 0, 'text-color-crimson': sum_total < 0}">
                <span>{{ sum_total >= 0 ? 'Thu' : 'Bù' }}</span>
                <span>: {{ sum_total | numeral('0,0[.]0') }} x {{ total_percent }}% </span>
                <span>= {{ sum_result | numeral('0,0[.]0') }}</span>
              </th>
            </tr>
            </tfoot>
          </table>
        </div>
      </f7-col>
    </f7-row>
    <f7-block class="mt-1 mb-1">
      <f7-row>
        <f7-col>
          <f7-button class="button-medium" fill color="red" @click.prevent="removeMessage">Xóa tin</f7-button>
        </f7-col>
        <f7-col>
          <f7-button class="button-medium" fill color="green" @click.prevent="goToEdit">Sửa tin</f7-button>
        </f7-col>
      </f7-row>
    </f7-block>
    <f7-row>
      <f7-col>
        <f7-card class="mt-1 mb-1">
          <f7-card-content>
            {{ message.content_original }}
          </f7-card-content>
        </f7-card>
      </f7-col>
    </f7-row>
    <f7-block strong inset v-if="!_.isEmpty(parsed_messages)" class="mt-0">
      <f7-row class="border-bottom-thin-solid font-bold pb-1">
        <f7-col>ĐÀI</f7-col>
        <f7-col>SỐ</f7-col>
        <f7-col>CÚ PHÁP</f7-col>
        <f7-col>{{ playStyle !== 'mb_ngan' ? 'ĐIỂM' : 'GIÁ TIỀN' }}</f7-col>
      </f7-row>
      <virtual-list style="height: 300px; overflow-y: auto;"
                    :data-key="'uid'"
                    :data-sources="parsed_messages"
                    :data-component="itemComponent"
      />
    </f7-block>
  </f7-page>
</template>
<script>
import moment from 'moment';
import { mapState } from 'vuex';
import VirtualList from 'vue-virtual-scroll-list'
import ItemNumberCommand from "@/components/ItemNumberCommand";
import Big from 'big.js';

export default {
  components: {
    VirtualList
  },
  props: {
    region: String,
    playStyle: String,
    custId: String,
    messageId: String,
  },
  data() {
    return {
      message: {},
      regions: {
        mn: 'Miền Nam',
        mb: 'Miền Bắc',
        mt: 'Miền Trung'
      },
      itemComponent: ItemNumberCommand
    }
  },
  computed: {
    ...mapState(['selected_drawdate']),
    parsed_messages() {
      if (this._.isEmpty(this.message.content_json)) {
        return [];
      }

      let msgs = [];
      let current_stt = 0;
      this._.each(this.message.content_json, (msg, msg_idx) => {
        this._.each(msg.numbers, (num, num_idx) => {
          current_stt += 1;
          msgs.push({
            uid: msg_idx + '_' + num_idx,
            stt: current_stt,
            label: null,
            channel: msg.channel,
            number: this._.isArray(num) ? num.join(' - ') : num,
            command: msg.display_command,
            point: msg.point,
            unit: this._.isUndefined(msg.unit) ? '' : msg.unit,
            is_win: this.isWin(msg.number_type, msg.channel, msg.command, num),
            is_win_ui: this.isWinUi(msg.number_type, msg.channel, msg.command, num)
          });
        });
      });

      return this._.orderBy(msgs, ['is_win', 'is_win_ui', 'stt'], ['desc', 'desc', 'asc']);
    },
    sum_point_1c() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        if (!this._.isUndefined(this.message.report_json['1c'])) {
          sum += this.message.report_json['1c'].point.ngang;
        }
      }
      return sum;
    },
    sum_point_giainhat() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json) && !this._.isUndefined(this.message.report_json['2c'].point.giainhat)) {
        sum += this.message.report_json['2c'].point.giainhat;
        sum += this.message.report_json['2c'].point.daunhat;
      }
      return sum;
    },
    sum_point_2c_bao() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].point.baolo;
      }
      return sum;
    },
    sum_point_2c_bay() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].point.baylo;
      }
      return sum;
    },
    sum_point_2c_tam() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].point.tamlo;
      }
      return sum;
    },
    sum_point_2c_dd() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].point.dau;
        sum += this.message.report_json['2c'].point.duoi;
        if (!this._.isUndefined(this.message.report_json['2c'].point.ke)) {
          sum += this.message.report_json['2c'].point.ke;
        }
      }
      return sum;
    },
    sum_point_2c_dat() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].point.dat;
      }
      return sum;
    },
    sum_point_2c_dax() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].point.dx;
      }
      return sum;
    },
    sum_point_2c_dax2() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].point.dx_2;
      }
      return sum;
    },
    sum_point_2c_dax3() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].point.dx_3;
      }
      return sum;
    },
    sum_point_2c_dax4() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].point.dx_4;
      }
      return sum;
    },
    sum_point_3c_bao() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].point.baolo;
      }
      return sum;
    },
    sum_point_3c_bay() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].point.baylo;
      }
      return sum;
    },
    sum_point_3c_xc() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].point.dau;
        sum += this.message.report_json['3c'].point.duoi;
        if (!this._.isUndefined(this.message.report_json['3c'].point.ke)) {
          sum += this.message.report_json['3c'].point.ke;
        }
      }
      return sum;
    },
    sum_point_4c() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['4c'].point.dat;
        sum += this.message.report_json['4c'].point.dx;
        sum += this.message.report_json['4c'].point.baolo;
        sum += this.message.report_json['4c'].point.dau;
        sum += this.message.report_json['4c'].point.duoi;
        sum += this.message.report_json['4c'].point.baylo;
      }
      return sum;
    },
    sum_cost_1c() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        if (!this._.isUndefined(this.message.report_json['1c'])) {
          sum += this.message.report_json['1c'].cost.ngang;
        }
      }
      return sum;
    },
    sum_cost_giainhat() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json) && !this._.isUndefined(this.message.report_json['2c'].point.giainhat)) {
        sum += this.message.report_json['2c'].cost.giainhat;
        sum += this.message.report_json['2c'].cost.daunhat;
      }
      return sum;
    },
    sum_cost_2c_bao() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost.baolo;
      }
      return sum;
    },
    sum_cost_2c_bay() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost.baylo;
      }
      return sum;
    },
    sum_cost_2c_tam() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost.tamlo;
      }
      return sum;
    },
    sum_cost_2c_dd() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost.dau;
        sum += this.message.report_json['2c'].cost.duoi;
        if (!this._.isUndefined(this.message.report_json['2c'].cost.ke)) {
          sum += this.message.report_json['2c'].cost.ke;
        }
      }
      return sum;
    },
    sum_cost_2c_dat() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost.dat;
      }
      return sum;
    },
    sum_cost_2c_dax() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost.dx;
      }
      return sum;
    },
    sum_cost_2c_dax2() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost.dx_2;
      }
      return sum;
    },
    sum_cost_2c_dax3() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost.dx_3;
      }
      return sum;
    },
    sum_cost_2c_dax4() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost.dx_4;
      }
      return sum;
    },
    sum_cost_3c_bao() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].cost.baolo;
      }
      return sum;
    },
    sum_cost_3c_bay() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].cost.baylo;
      }
      return sum;
    },
    sum_cost_3c_xc() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].cost.dau;
        sum += this.message.report_json['3c'].cost.duoi;
        if (!this._.isUndefined(this.message.report_json['3c'].cost.ke)) {
          sum += this.message.report_json['3c'].cost.ke;
        }
      }
      return sum;
    },
    sum_cost_4c() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['4c'].cost.dat;
        sum += this.message.report_json['4c'].cost.dx;
        sum += this.message.report_json['4c'].cost.baolo;
        sum += this.message.report_json['4c'].cost.dau;
        sum += this.message.report_json['4c'].cost.duoi;
        sum += this.message.report_json['4c'].cost.baylo;
      }
      return sum;
    },
    sum_cost_without_rate_1c() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        if (!this._.isUndefined(this.message.report_json['1c'])) {
          sum += this.message.report_json['1c'].cost_without_rate.ngang;
        }
      }
      return sum;
    },
    sum_cost_without_rate_giainhat() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json) && !this._.isUndefined(this.message.report_json['2c'].point.giainhat)) {
        sum += this.message.report_json['2c'].cost_without_rate.giainhat;
        sum += this.message.report_json['2c'].cost_without_rate.daunhat;
      }
      return sum;
    },
    sum_cost_without_rate_2c_bao() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost_without_rate.baolo;
      }
      return sum;
    },
    sum_cost_without_rate_2c_bay() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost_without_rate.baylo;
      }
      return sum;
    },
    sum_cost_without_rate_2c_tam() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost_without_rate.tamlo;
      }
      return sum;
    },
    sum_cost_without_rate_2c_dd() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost_without_rate.dau;
        sum += this.message.report_json['2c'].cost_without_rate.duoi;
        if (!this._.isUndefined(this.message.report_json['2c'].cost_without_rate.ke)) {
          sum += this.message.report_json['2c'].cost_without_rate.ke;
        }
      }
      return sum;
    },
    sum_cost_without_rate_2c_dat() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost_without_rate.dat;
      }
      return sum;
    },
    sum_cost_without_rate_2c_dax() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost_without_rate.dx;
      }
      return sum;
    },
    sum_cost_without_rate_2c_dax2() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost_without_rate.dx_2;
      }
      return sum;
    },
    sum_cost_without_rate_2c_dax3() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost_without_rate.dx_3;
      }
      return sum;
    },
    sum_cost_without_rate_2c_dax4() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].cost_without_rate.dx_4;
      }
      return sum;
    },
    sum_cost_without_rate_3c_bao() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].cost_without_rate.baolo;
      }
      return sum;
    },
    sum_cost_without_rate_3c_bay() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].cost_without_rate.baylo;
      }
      return sum;
    },
    sum_cost_without_rate_3c_xc() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].cost_without_rate.dau;
        sum += this.message.report_json['3c'].cost_without_rate.duoi;
        if (!this._.isUndefined(this.message.report_json['3c'].cost_without_rate.ke)) {
          sum += this.message.report_json['3c'].cost_without_rate.ke;
        }
      }
      return sum;
    },
    sum_cost_without_rate_4c() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['4c'].cost_without_rate.dat;
        sum += this.message.report_json['4c'].cost_without_rate.dx;
        sum += this.message.report_json['4c'].cost_without_rate.baolo;
        sum += this.message.report_json['4c'].cost_without_rate.dau;
        sum += this.message.report_json['4c'].cost_without_rate.duoi;
        sum += this.message.report_json['4c'].cost_without_rate.baylo;
      }
      return sum;
    },
    sum_win_1c() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        if (!this._.isUndefined(this.message.report_json['1c'])) {
          sum += this.message.report_json['1c'].win.ngang;
        }
      }
      return sum;
    },
    sum_win_giainhat() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json) && !this._.isUndefined(this.message.report_json['2c'].point.giainhat)) {
        sum += this.message.report_json['2c'].win.giainhat;
        sum += this.message.report_json['2c'].win.daunhat;
      }
      return sum;
    },
    sum_win_2c_bao() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win.baolo;
      }
      return sum;
    },
    sum_win_2c_ui() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += (this._.isNumber(this.message.report_json['2c'].win.ui)) ? this.message.report_json['2c'].win.ui : 0;
      }
      return sum;
    },
    sum_win_2c_bay() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win.baylo;
      }
      return sum;
    },
    sum_win_2c_tam() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win.tamlo;
      }
      return sum;
    },
    sum_win_2c_dd() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win.dau;
        sum += this.message.report_json['2c'].win.duoi;
        if (!this._.isUndefined(this.message.report_json['2c'].win.ke)) {
          sum += this.message.report_json['2c'].win.ke;
        }
      }
      return sum;
    },
    sum_win_2c_dat() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win.dat;
      }
      return sum;
    },
    sum_win_2c_dax() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win.dx;
      }
      return sum;
    },
    sum_win_2c_dax2() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win.dx_2;
      }
      return sum;
    },
    sum_win_2c_dax3() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win.dx_3;
      }
      return sum;
    },
    sum_win_2c_dax4() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win.dx_4;
      }
      return sum;
    },
    sum_win_3c_bao() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].win.baolo;
      }
      return sum;
    },
    sum_win_3c_bay() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].win.baylo;
      }
      return sum;
    },
    sum_win_3c_xc() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].win.dau;
        sum += this.message.report_json['3c'].win.duoi;
        if (!this._.isUndefined(this.message.report_json['3c'].win.ke)) {
          sum += this.message.report_json['3c'].win.ke;
        }
      }
      return sum;
    },
    sum_win_4c() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['4c'].win.dat;
        sum += this.message.report_json['4c'].win.dx;
        sum += this.message.report_json['4c'].win.baolo;
        sum += this.message.report_json['4c'].win.dau;
        sum += this.message.report_json['4c'].win.duoi;
        sum += this.message.report_json['4c'].win.baylo;
      }
      return sum;
    },
    sum_win_without_win_rate_1c() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        if (!this._.isUndefined(this.message.report_json['1c'])) {
          sum += this.message.report_json['1c'].win_without_win_rate.ngang;
        }
      }
      return sum;
    },
    sum_win_without_win_rate_giainhat() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json) && !this._.isUndefined(this.message.report_json['2c'].point.giainhat)) {
        sum += this.message.report_json['2c'].win_without_win_rate.giainhat;
        sum += this.message.report_json['2c'].win_without_win_rate.daunhat;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_bao() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win_without_win_rate.baolo;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_bay() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win_without_win_rate.baylo;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_ui() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += (this._.isNumber(this.message.report_json['2c'].win_without_win_rate.ui)) ? this.message.report_json['2c'].win_without_win_rate.ui : 0;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_tam() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win_without_win_rate.tamlo;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_dd() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win_without_win_rate.dau;
        sum += this.message.report_json['2c'].win_without_win_rate.duoi;
        if (!this._.isUndefined(this.message.report_json['2c'].win_without_win_rate.ke)) {
          sum += this.message.report_json['2c'].win_without_win_rate.ke;
        }
      }
      return sum;
    },
    sum_win_without_win_rate_2c_dat() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win_without_win_rate.dat;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_dax() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win_without_win_rate.dx;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_dax2() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win_without_win_rate.dx_2;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_dax3() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win_without_win_rate.dx_3;
      }
      return sum;
    },
    sum_win_without_win_rate_2c_dax4() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['2c'].win_without_win_rate.dx_4;
      }
      return sum;
    },
    sum_win_without_win_rate_3c_bao() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].win_without_win_rate.baolo;
      }
      return sum;
    },
    sum_win_without_win_rate_3c_bay() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].win_without_win_rate.baylo;
      }
      return sum;
    },
    sum_win_without_win_rate_3c_xc() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['3c'].win_without_win_rate.dau;
        sum += this.message.report_json['3c'].win_without_win_rate.duoi;
        if (!this._.isUndefined(this.message.report_json['3c'].win_without_win_rate.ke)) {
          sum += this.message.report_json['3c'].win_without_win_rate.ke;
        }
      }
      return sum;
    },
    sum_win_without_win_rate_4c() {
      let sum = 0;
      if (!this._.isEmpty(this.message.report_json)) {
        sum += this.message.report_json['4c'].win_without_win_rate.dat;
        sum += this.message.report_json['4c'].win_without_win_rate.dx;
        sum += this.message.report_json['4c'].win_without_win_rate.baolo;
        sum += this.message.report_json['4c'].win_without_win_rate.dau;
        sum += this.message.report_json['4c'].win_without_win_rate.duoi;
        sum += this.message.report_json['4c'].win_without_win_rate.baylo;
      }
      return sum;
    },
    sum_total() {
      if (this._.isEmpty(this.message.customer)) {
        return 0;
      }

      let sum = new Big(0);

      sum = sum.plus(this.sum_cost_1c);
      sum = sum.plus(this.sum_cost_giainhat);
      sum = sum.plus(this.sum_cost_2c_bao);
      sum = sum.plus(this.sum_cost_2c_bay);
      sum = sum.plus(this.sum_cost_2c_tam);
      sum = sum.plus(this.sum_cost_2c_dd);
      sum = sum.plus(this.sum_cost_2c_dat);
      sum = sum.plus(this.sum_cost_2c_dax);
      sum = sum.plus(this.sum_cost_2c_dax2);
      sum = sum.plus(this.sum_cost_2c_dax3);
      sum = sum.plus(this.sum_cost_2c_dax4);

      sum = sum.minus(this.sum_win_1c);
      sum = sum.minus(this.sum_win_giainhat);
      sum = sum.minus(this.sum_win_2c_bao);
      sum = sum.minus(this.sum_win_2c_bay);
      sum = sum.minus(this.sum_win_2c_tam);
      sum = sum.minus(this.sum_win_2c_dd);
      sum = sum.minus((this._.isNumber(this.sum_win_2c_ui)) ? this.sum_win_2c_ui : 0);
      sum = sum.minus(this.sum_win_2c_dat);
      sum = sum.minus(this.sum_win_2c_dax);
      sum = sum.minus(this.sum_win_2c_dax2);
      sum = sum.minus(this.sum_win_2c_dax3);
      sum = sum.minus(this.sum_win_2c_dax4);

      sum = sum.plus(this.sum_cost_3c_bao);
      sum = sum.plus(this.sum_cost_3c_bay);
      sum = sum.plus(this.sum_cost_3c_xc);
      sum = sum.plus(this.sum_cost_4c);

      sum = sum.minus(this.sum_win_3c_bao);
      sum = sum.minus(this.sum_win_3c_bay);
      sum = sum.minus(this.sum_win_3c_xc);
      sum = sum.minus(this.sum_win_4c);

      return (this.message.customer.type === 1) ? sum.toNumber() : -sum.toNumber();
    },
    sum_result() {
      let sum = new Big(0);
      if (!this._.isEmpty(this.message.report_json)) {
        if (!this._.isUndefined(this.message.report_json['1c'])) {
          sum = sum.plus(this.message.report_json['1c'].result.ngang);
        }
        if (!this._.isUndefined(this.message.report_json['2c'].result.giainhat)) {
          sum = sum.plus(this.message.report_json['2c'].result.giainhat);
          sum = sum.plus(this.message.report_json['2c'].result.daunhat);
        }
        sum = sum.plus(this.message.report_json['2c'].result.dat);
        sum = sum.plus(this.message.report_json['2c'].result.dx);
        sum = sum.plus(this.message.report_json['2c'].result.dx_2);
        sum = sum.plus(this.message.report_json['2c'].result.dx_3);
        sum = sum.plus(this.message.report_json['2c'].result.dx_4);
        sum = sum.plus(this.message.report_json['2c'].result.baolo);
        sum = sum.plus(this.message.report_json['2c'].result.dau);
        sum = sum.plus(this.message.report_json['2c'].result.duoi);
        sum = sum.plus(this.message.report_json['2c'].result.baylo);
        sum = sum.plus(this.message.report_json['2c'].result.tamlo);
        sum = sum.plus(this._.isNumber(this.message.report_json['2c'].result.ui) ? this.message.report_json['2c'].result.ui : 0);
        sum = sum.plus(!this._.isUndefined(this.message.report_json['2c'].result.ke) ? this.message.report_json['2c'].result.ke : 0);

        sum = sum.plus( this.message.report_json['3c'].result.dat);
        sum = sum.plus( this.message.report_json['3c'].result.dx);
        sum = sum.plus( this.message.report_json['3c'].result.baolo);
        sum = sum.plus( this.message.report_json['3c'].result.dau);
        sum = sum.plus( this.message.report_json['3c'].result.duoi);
        sum = sum.plus( this.message.report_json['3c'].result.baylo);
        sum = sum.plus( (!this._.isUndefined(this.message.report_json['3c'].result.ke)) ? this.message.report_json['3c'].result.ke : 0);

        sum = sum.plus( this.message.report_json['4c'].result.dat );
        sum = sum.plus( this.message.report_json['4c'].result.dx );
        sum = sum.plus( this.message.report_json['4c'].result.baolo );
        sum = sum.plus( this.message.report_json['4c'].result.dau );
        sum = sum.plus( this.message.report_json['4c'].result.duoi );
        sum = sum.plus( this.message.report_json['4c'].result.baylo );
      }
      return sum.toNumber();
    },
    total_percent() {
      if (this._.isEmpty(this.message.customer)) {
        return 0;
      }
      if (this.playStyle === 'mb_ngan') {
        return this.message.customer.config_deal.mb_ngan.total_percent;
      }
      else if (this.playStyle === 'mb_buonme') {
        return this.message.customer.config_deal.mb_buonme.total_percent;
      }
      else if (this.playStyle === 'mn_buonme') {
        return this.message.customer.config_deal.mn_buonme.total_percent;
      }
      else if (this.playStyle === 'mb_hanoi') {
        return this.message.customer.config_deal.mb_hanoi.total_percent;
      }
      else if (this.playStyle === 'mt_buonme') {
        return this.message.customer.config_deal.mt_buonme.total_percent;
      }
      return this.message.customer.config_deal[this.region].total_percent;
    }
  },
  methods: {
    getMessageDetail() {
      this.$f7.dialog.preloader();

      this.$store.dispatch('getMessageDetail', {
        message_id: this.messageId
      }).then((data) => {
        this.$f7.dialog.close();
        this.message = data;
      }).catch((err) => {
        this.$f7.dialog.close();
        this.$f7.dialog.alert(err, 'LỖI!');
      })
    },
    goToEdit() {
      let style = this._.isEmpty(this.message.play_style) ? 'default' : this.message.play_style;
      this.$f7router.navigate(`/xu-ly/${this.region}/${style}/khach-hang/${this.custId}/sua-tin-nhan/${this.messageId}`, {
        props: {
          drawDate: moment(this.selected_drawdate).format('YYYY-MM-DD'),
          message: this.message
        }
      });
    },
    removeMessage() {
      const self = this;
      this.$f7.dialog.confirm('Bạn có chắc chắn muốn xóa Tin nhắn này?', 'THÔNG BÁO!', () => {
        self.$f7.dialog.preloader();
        self.$store.dispatch('removeMessage', {
          id: this.messageId
        }).then(() => {
          self.$f7.dialog.close();
          this.$f7router.back();
        }).catch((err) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert(err, 'LỖI!');
        });
      });
    },
    isWin(number_type, channel, command, numbers) {
      let existed_win = this._.find(this.message.report_json[number_type].result_numbers_match[command], {
        'channel': channel,
        'number': numbers
      });
      return !this._.isEmpty(existed_win) ? existed_win.times : 0;
    },
    isWinUi(number_type, channel, command, numbers) {
      if (['baolo', 'lo'].indexOf(command) >= 0) {
        let existed_win = this._.find(this.message.report_json[number_type].result_numbers_match['ui'], {
          'channel': channel,
          'number': numbers,
          'ui_type': 'baolo'
        });
        return !this._.isEmpty(existed_win) ? existed_win.times : 0;
      }
      else if (['dau'].indexOf(command) >= 0) {
        let existed_win = this._.find(this.message.report_json[number_type].result_numbers_match['ui'], {
          'channel': channel,
          'number': numbers,
          'ui_type': 'dau'
        });
        return !this._.isEmpty(existed_win) ? existed_win.times : 0;
      }
      else if (['duoi'].indexOf(command) >= 0) {
        let existed_win = this._.find(this.message.report_json[number_type].result_numbers_match['ui'], {
          'channel': channel,
          'number': numbers,
          'ui_type': 'duoi'
        });
        return !this._.isEmpty(existed_win) ? existed_win.times : 0;
      }
      return 0;
    }
  }
};
</script>

